import { Directive, HostListener, Renderer2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appSidemenuToggle]'
})
export class SidemenuToggleDirective {
  private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);

  /** Inserted by Angular inject() migration for backwards compatibility */


  constructor() { }

  @HostListener('click') toggleSidemenu() {
    const body = this.document.body;
    if (body.classList.contains('sidenav-toggled')) {
      this.renderer.removeClass(body, 'sidenav-toggled');
    } else {
      this.renderer.addClass(body, 'sidenav-toggled');
    }
  }
}
